import CrudPage from "../components/CrudPage";

export default function Suppliers() {
  return (
    <CrudPage
      title="Tedarikçiler"
      subtitle="Tedarikçi firma kayıtlarını yönetin"
      module="suppliers"
      endpoint="/suppliers"
      addLabel="Yeni Tedarikçi"
      columns={[
        { key: "company", label: "Firma", render: (r) => <span className="font-medium">{r.company}</span> },
        { key: "contact", label: "Yetkili" },
        { key: "phone", label: "Telefon" },
        { key: "address", label: "Adres" },
        { key: "tax_info", label: "Vergi Bilgileri" },
        { key: "notes", label: "Notlar" },
      ]}
      fields={[
        { name: "company", label: "Firma Adı", required: true },
        { name: "contact", label: "Yetkili" },
        { name: "phone", label: "Telefon" },
        { name: "tax_info", label: "Vergi Bilgileri" },
        { name: "address", label: "Adres", colSpan: 2 },
        { name: "notes", label: "Notlar", type: "textarea" },
      ]}
    />
  );
}
